import React, { useEffect, useState } from 'react'
import { getHomeCategories } from '../../services/CategoriesService'
import { Link } from 'react-router-dom'
import RedirectWithConfirm from './RedirectWithConfirm'

const categoryPaths = {
  'Hire Farm Labour': '/hire-farm-labour',
  'Rent/Lease/Sale': '/all-product',
  "Farmer's City Mart": '/farmer-shop',
  'Progressive Farming Solutions': '/progressive-farming-solutions',
  Consultation: '/consultation',
  'Drone Services': 'external-drone', // flag to show confirmation modal
  'Gaon Se': '/gaon-se'
}

const externalUrls = {
  'external-drone': 'https://droneplanet.in/aboutdaas'
}

const ShopByCategory = () => {
  const [categories, setCategories] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [externalUrl, setExternalUrl] = useState(null)

  useEffect(() => {
    const fetchCategories = async () => {
      const res = await getHomeCategories()
      setCategories(res)
    }
    fetchCategories()
  }, [])

  const handleClick = redirect => {
    if (redirect === 'external-drone') {
      setExternalUrl(externalUrls[redirect])
      setShowModal(true)
    }
  }

  const confirmRedirect = () => {
    setShowModal(false)
    if (externalUrl) {
      window.open(externalUrl, '_blank') // open external link in new tab
      setExternalUrl(null)
    }
  }

  const cancelRedirect = () => {
    setShowModal(false)
    setExternalUrl(null)
  }

  return (
    <div className='py-5'>
      <div className='container'>
        <h2 className='text-center fw-bold mb-4'>
          Shop by <span className='text-success'>Category</span>
        </h2>
        <p className='text-center text-muted mb-5'>
          Tap a category to explore 🌿
        </p>

        <div className='d-flex flex-wrap justify-content-center gap-3'>
          {categories &&
            categories.map((item, index) => {
              const redirect = categoryPaths[item.name]
              const content = (
                <div className='category-chip d-flex align-items-center px-3 py-2 shadow-sm rounded-pill'>
                  <img
                    src={item.image}
                    alt={item.name}
                    className='me-2'
                    style={{
                      width: '28px',
                      height: '28px',
                      objectFit: 'cover'
                    }}
                  />
                  <span className='fw-semibold'>{item.name}</span>
                </div>
              )

              if (!redirect) return <div key={index}>{content}</div>

              // Drone Services: external redirect with confirmation
              if (redirect === 'external-drone') {
                return (
                  <div
                    key={index}
                    className='cursor-pointer'
                    onClick={() => handleClick(redirect)}
                  >
                    {content}
                  </div>
                )
              }

              // Internal route
              return (
                <Link
                  key={index}
                  to={redirect}
                  className='text-decoration-none text-dark'
                >
                  {content}
                </Link>
              )
            })}
        </div>

        {/* Confirmation Modal for external links */}
        <RedirectWithConfirm
          show={showModal}
          url={externalUrl}
          onCancel={cancelRedirect}
          onConfirm={confirmRedirect}
        />
      </div>
    </div>
  )
}

export default ShopByCategory
